import { PageListDataSource } from './BaseDataSources';
import { ILsDomainField } from "@/Interfaces";

export class LsDomainFieldSource extends PageListDataSource<ILsDomainField> {
  public constructor() {
    super('/datasource/ls/domainfields', { }, 100);
  }
}